"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubtotalStyles = exports.isSomeTotal = exports.isInvalidGetRowsRequest = exports.areTotalsChanged = void 0;
var tslib_1 = require("tslib");
var agApiWrapper_1 = tslib_1.__importDefault(require("../base/agApiWrapper"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var constants_1 = require("../base/constants");
function areTotalsChanged(gridApi, newTotals) {
    var _a, _b;
    var currentTotalsCount = (_a = gridApi === null || gridApi === void 0 ? void 0 : gridApi.getPinnedBottomRowCount()) !== null && _a !== void 0 ? _a : 0;
    var newTotalsCount = (_b = newTotals === null || newTotals === void 0 ? void 0 : newTotals.length) !== null && _b !== void 0 ? _b : 0;
    if (currentTotalsCount !== newTotalsCount) {
        return true;
    }
    for (var i = 0; i < currentTotalsCount; i++) {
        if (!isEqual_1.default(gridApi === null || gridApi === void 0 ? void 0 : gridApi.getPinnedBottomRow(i).data, newTotals[i])) {
            return true;
        }
    }
    return false;
}
exports.areTotalsChanged = areTotalsChanged;
function isInvalidGetRowsRequest(startRow, gridApi) {
    var bottomRowIndex = gridApi ? agApiWrapper_1.default.getPaginationBottomRowIndex(gridApi) : null;
    if (bottomRowIndex !== null) {
        return startRow > bottomRowIndex;
    }
    return false;
}
exports.isInvalidGetRowsRequest = isInvalidGetRowsRequest;
function isSomeTotal(rowType) {
    var isRowTotal = rowType === constants_1.ROW_TOTAL;
    var isRowSubtotal = rowType === constants_1.ROW_SUBTOTAL;
    return isRowTotal || isRowSubtotal;
}
exports.isSomeTotal = isSomeTotal;
function getSubtotalStyles(dimension) {
    if (!(dimension === null || dimension === void 0 ? void 0 : dimension.totals)) {
        return [];
    }
    var even = false;
    var subtotalStyles = dimension.itemIdentifiers.slice(1).map(function (attributeIdentifier) {
        var _a, _b;
        var hasSubtotal = (_b = (_a = dimension.totals) === null || _a === void 0 ? void 0 : _a.some(function (total) { return total.attributeIdentifier === attributeIdentifier; })) !== null && _b !== void 0 ? _b : false;
        if (hasSubtotal) {
            even = !even;
            return even ? "even" : "odd";
        }
        return null;
    });
    // Grand total (first) has no styles
    return tslib_1.__spreadArrays([null], subtotalStyles);
}
exports.getSubtotalStyles = getSubtotalStyles;
//# sourceMappingURL=dataSourceUtils.js.map